<template>
  <Breadcrumbs
    :breadcrumbs="[
      { name: 'Dashboard', href: route('dashboard') },
      { name: `Kinerja Program Studi`, href: route('evaluasi.index') },
      {
        name: `${filerepo.data[0].nama_dok}`,
        href: route('evaluasi.show', filerepo.data[0].iddok),
      },
    ]"
  />
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
    <div class="h-auto">
      <div class="flow-root py-3 border rounded-lg shadow-xs">
        <dl class="-my-3 text-sm divide-y divide-gray-100">
          <div class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-900">Nama Dokumen</dt>
            <dd class="text-gray-700 sm:col-span-2">
              {{ filerepo.data[0].nama_dok }}
            </dd>
          </div>

          <div class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-900">Jenis</dt>
            <dd class="text-gray-700 sm:col-span-2">
              {{ filerepo.data[0].jenisdokumen.nama }}
            </dd>
          </div>
          <div class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-900">Deskripsi</dt>
            <dd class="text-gray-700 sm:col-span-2">
              {{ filerepo.data[0].deskripsi }}
            </dd>
          </div>
          <div class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-900">Kategori Data</dt>
            <dd class="text-gray-700 sm:col-span-2">
              {{ filerepo.data[0].publish }}
            </dd>
          </div>
          <div
            class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4"
            v-if="$page.props.auth.user"
          >
            <dd class="text-gray-700 sm:col-span-2">
              <div class="flex justify-center space-x-4">
                <span>
                  <button
                    @click="editDokumen(filerepo.data[0].iddok)"
                    class="flex items-center px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="w-4 h-4 mr-1"
                    >
                      <path
                        d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z"
                      />
                      <path
                        d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z"
                      />
                    </svg>

                    Edit Dokumen
                  </button>
                </span>
                <span>
                  <button
                    @click="editFile(filerepo.data[0].iddok)"
                    class="flex items-center px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="w-4 h-4 mr-1"
                    >
                      <path
                        d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z"
                      />
                      <path
                        d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z"
                      />
                    </svg>

                    Edit File
                  </button>
                </span>
              </div>
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="h-auto rounded-lg lg:col-span-2">
      <!-- Display multiple files -->
      <div v-if="filePath && filePath.length" class="mt-4">
        <div v-for="(file, index) in filePath" :key="index" class="mb-4">
          <div
            v-if="isImage(file)"
            class="inline-block p-2 border rounded-lg"
            style="width: 300px; height: 300px; margin: 5px; overflow: hidden"
          >
            <img
              :src="file"
              alt="Image Preview"
              class="object-cover w-full h-full"
            />
          </div>
          <embed
            v-else-if="isPdf(file)"
            :src="file"
            type="application/pdf"
            class="w-full h-[80vh] mb-2"
          />
          <p v-else>Preview not available for this file type: {{ file }}</p>
        </div>
      </div>
      <ModalEditDokumen
        v-model:isOpen="isModalOpen"
        :title="'Edit Dokumen'"
        :repository="viewdokumen"
        :prodis="selectedProdi"
        :jenis="selectedJenis"
      />
      <ModalFile
        v-model:isOpen="isModalFile"
        :title="'Edit File'"
        :repository="viewdokumen"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, watch, ref } from "vue";
import ModalEditDokumen from "@/Components/Kinerja/ModalEditDokumen.vue";
import ModalFile from "@/Components/Kinerja/ModalFile.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

const props = defineProps({
  filerepo: {
    type: Array,
    required: true,
  },
});
const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);

const filePath = ref(props.filerepo.data[0].file_path);

watch(
  () => props.filerepo,
  (newFilerepo) => {
    filePath.value = newFilerepo.data[0].file_path;
  }
);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(`/viewdocevaluasi/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
const editFile = async (iddok) => {
  try {
    const response = await fetch(`/viewdocevaluasi/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}
</script>
